import { api } from './api';

/** One platform-wide runtime setting (APP_CONFIG_REGISTRY), as the code resolves it. */
export interface AppSetting {
  key: string;
  value: unknown;
  valueType: 'int' | 'float' | 'bool' | 'string' | 'list' | 'dict';
  description: string;
  defaultValue: unknown;
  min?: number | null;
  max?: number | null;
  isOverridden: boolean;
}

export const appSettingsService = {
  list: async (): Promise<AppSetting[]> =>
    (await api.get<{ data: AppSetting[] }>('/api/v1/app-settings')).data.data,
  update: async (key: string, value: unknown): Promise<void> => {
    await api.put(`/api/v1/app-settings/${encodeURIComponent(key)}`, { value });
  },
};
